import {
  TextureLoader,
  BufferGeometry,
  BufferAttribute,
  Points,
  ShaderMaterial,
  Object3D,
  AdditiveBlending,
  MeshDepthMaterial,
  Vector2,
  Vector3,
  MeshBasicMaterial,
  Color,
  Box3
} from 'three'

import { randomRange } from '@/utils/Maths'

import { Component } from 'shimmer'

import glsl from 'glslify'

export class Particles extends Component {
  constructor ({
    color = 0xffffff,
    positions = [],
    opacity = 1,
    size = new Box3(new Vector3(-50, -50, -50), new Vector3(50, 50, 50) ),
    speed = new Vector2(0, 0),
    particleSize = 15
  } = {}) {
    super({ name: 'Particles' })

    this.size = size
    this.positions = positions
    this.color = new Color(color)
    this.geometry = new BufferGeometry()
    this.vertices = new Float32Array(this.positions.length * 3)
    this.progress = new Float32Array(this.positions.length)

    const sizeVector = new Vector3()
    const centerVector = new Vector3()
    this.size.getSize(sizeVector)
    this.size.getCenter(centerVector)

    this.uniforms = {
      uColor: { type: 'f', value: this.color },
      uTime: { type: 'f', value: 0.0 },
      uMap: { type: 't', value: null },
      uNoiseTexture: { type: 't', value: null },
      uSize: { type: 'vec3', value: sizeVector },
      uParticleSize: { type: 'f', value: particleSize }
    }

    this.setup()
  }

  loadTextures () {
    this.textureParticle = null
    this.textureNoise = null

    return Promise.all([
      new Promise((resolve, reject) => {
        new TextureLoader().load('/images/particle-2.png', (texture) => {
          this.textureParticle = texture
          resolve()
        })
      }),
      new Promise((resolve, reject) => {
        new TextureLoader().load('/images/perlin-noise.jpg', (texture) => {
          this.textureNoise = texture
          resolve()
        })
      })
    ])
  }

  get opacity () {
    return this.uniforms.uOpacity.value
  }

  set opacity (opacity) {
    this.uniforms.uOpacity.value = opacity
  }

  get particleSize () {
    return this.uniforms.uParticleSize.value
  }

  set particleSize (particleSize) {
    this.uniforms.uParticleSize.value = particleSize
  }

  async setup () {
    await this.loadTextures()

    this.uniforms.uMap.value = this.textureParticle
    this.uniforms.uNoiseTexture.value = this.textureNoise

    for (let i = 0; i < this.positions.length; i++) {
      this.vertices[i * 3] = this.positions[i].x
      this.vertices[i * 3 + 1] = this.positions[i].y
      this.vertices[i * 3 + 2] = this.positions[i].z

      this.progress[i] = Math.random()
    }

    this.geometry.setAttribute('position', new BufferAttribute(this.vertices, 3))
    this.geometry.setAttribute('progress', new BufferAttribute(this.progress, 1))

    this.material = new ShaderMaterial({
      uniforms: this.uniforms,
      transparent: true,
      depthTest: false,
      blending: AdditiveBlending,
      vertexShader: glsl(require('../shaders/particles.vert').default),
      fragmentShader: glsl(require('../shaders/particles.frag').default)
    })


    this.particleSystem = new Points(this.geometry, this.material)

    this.add(this.particleSystem)
  }

  onUpdate ({ elapsed }) {
    this.uniforms.uTime.value = elapsed * .00001
  }
}
